import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from './Avatar.js';
import { IconButton } from '../primitives/Button.js';
export function ChatHeader({ title, subtitle, avatarUrl, avatarColorKey, online, onBack, onSearch, onOpenProfile, }) {
    const bar = {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-2)',
        padding: 'var(--space-2) var(--space-3)',
        background: 'var(--color-surface)',
        borderBottom: '1px solid var(--color-divider)',
        minHeight: '56px',
    };
    return (_jsxs("header", { "data-chat-header": "", style: bar, children: [onBack ? _jsx(IconButton, { icon: "back", label: "\u041D\u0430\u0437\u0430\u0434", onClick: onBack, touch: true }) : null, _jsxs("button", { type: "button", "data-header-profile": "", onClick: onOpenProfile, style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--space-3)',
                    flex: 1,
                    minWidth: 0,
                    border: 'none',
                    background: 'transparent',
                    color: 'var(--color-text)',
                    cursor: onOpenProfile ? 'pointer' : 'default',
                    textAlign: 'left',
                    padding: 0,
                }, children: [_jsx(Avatar, { name: title, src: avatarUrl, size: 40, online: online, colorKey: avatarColorKey ?? title }), _jsxs("span", { style: { minWidth: 0, display: 'flex', flexDirection: 'column' }, children: [_jsx("span", { "data-header-title": "", style: {
                                    fontSize: 'var(--font-lg)',
                                    fontWeight: 'var(--weight-semibold)',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }, children: title }), subtitle ? (_jsx("span", { "data-header-subtitle": "", style: {
                                    fontSize: 'var(--font-sm)',
                                    color: 'var(--color-text-muted)',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }, children: subtitle })) : null] })] }), onSearch ? _jsx(IconButton, { icon: "search", label: "\u041F\u043E\u0438\u0441\u043A", onClick: onSearch }) : null] }));
}
//# sourceMappingURL=ChatHeader.js.map